
const vueApiAction = (action, options) => async (context, ...args) => {
  const {
    noConcurrency,
  } = options || {};

  const {
    commit,
    dispatch,

    getters,
    rootGetters = getters,
  } = context;

  try {
    if (noConcurrency) {
      if (rootGetters.concurrencyLock) {
        return;
      }

      commit('ACQUIRE_API_LOCK');
    }

    return await action(context, ...args);
  } catch (e) {
    const {
      response: {
        status,
      } = {},
    } = e || {};

    if (status === 401) {
      dispatch('logout', 'Istuntosi on päättynyt. Kirjaudu uudestaan sisään jatkaaksesi palvelun käyttöä');
    } else {
      console.log(e);

      commit('API_ERROR', true);
    }
  } finally {
    if (noConcurrency) {
      commit('RELEASE_API_LOCK');
    }
  }
};

export const apiAction = (action) => vueApiAction(action, {
  noConcurrency: true,
});

export const apiFetch = (action) => vueApiAction(action);

const state = {
  concurrencyLock: false,
  apiError: false,
  forceLogoutMessage: null,
};

const getters = {
  concurrencyLock: state => state.concurrencyLock,
  apiError: state => state.apiError,
  forceLogoutMessage: state => state.forceLogoutMessage,
};

const mutations = {
  ACQUIRE_API_LOCK: (state) => {
    state.concurrencyLock = true;
  },
  RELEASE_API_LOCK: (state) => {
    state.concurrencyLock = false;
  },
  API_ERROR: (state, apiError) => {
    state.apiError = apiError;
  },
  FORCE_LOGOUT_MESSAGE: (state, forceLogoutMessage) => {
    state.forceLogoutMessage = forceLogoutMessage || null;
  },
  RESET_FORCE_LOGOUT_MESSAGE: (state) => {
    state.forceLogoutMessage = null;
  },
};

const actions = {
};

export default {
  state,
  getters,
  mutations,
  actions,
};
